module.exports = __webpack_public_path__ + "static/img/10066K_1_2_R_20220110_LC.d51311e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10066K_1_2_R_20220110_LC.png
// module id = 5KTo
// module chunks = 0